export class ClosePopoutTimerService {
    private timer;
    private timeout;
    private selector;
    private timeoutDefaultValue = 100;
    private closePopoutFunc: Function = null;

    /**
     * Creates an instance of ClosePopoutTimerService.
     *
     * @param selector A CSS selector to select a popout in the DOM.
     * @param closePopoutFunc The function to be called to close the popout.
     * @param timeout Timeout value for timer. Optional parameter. Default value '100' milliseconds.
     */
    constructor(selector: string, closePopoutFunc: Function, timeout?: number) {
        this.selector = selector;
        if (!this.selector) {
            console.error('ClosePopoutTimerService error: "selector" is not set');
        }

        this.closePopoutFunc = closePopoutFunc;
        if (!this.closePopoutFunc) {
            console.error('ClosePopoutTimerService error: "closePopoutFunc" is not set');
        }

        this.timeout = timeout ? timeout : this.timeoutDefaultValue;
    }

    public startTimer = () => {
        if (this.timer) {
            return;
        }

        if (!this.closePopoutFunc) {
            return;
        }

        this.timer = setInterval(() => {
            // XTODO: JQUERY
            if ($(this.selector).length === 0) {
                this.closePopoutFunc();
                this.clearTimer();
            }
        }, this.timeout);
    };

    public clearTimer = (): void => {
        clearInterval(this.timer);
        this.timer = null;
    };
}
